<span
  #trigger
  class="hover-tooltip-trigger"
  (mouseenter)="onTriggerEnter()"
  (mouseleave)="onTriggerLeave($event)">
  <ng-content></ng-content>
</span>
<div
  #panel
  *ngIf="visible && contentTemplate"
  class="hover-tooltip-panel"
  [class.hover-tooltip-above]="showAbove"
  [style.left.px]="panelLeft"
  [style.top.px]="panelTop"
  (mouseenter)="onPanelEnter()"
  (mouseleave)="onPanelLeave()">
  <ng-container *ngTemplateOutlet="contentTemplate; context: templateContext"></ng-container>
</div>
